'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lruMemoize = require('lru-memoize');

var _lruMemoize2 = _interopRequireDefault(_lruMemoize);

var _validation = require('utils/validation');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var applicationFormValidation = (0, _validation.createValidator)({
  type: [_validation.required],
  variant: [_validation.required],
  tel: [_validation.required, _validation.phone],
  firstName: [_validation.required, (0, _validation.maxLength)(50)],
  lastName: [_validation.required, (0, _validation.maxLength)(50)],
  pin: [],
  street: [(0, _validation.maxLength)(50)],
  city: [_validation.required, (0, _validation.maxLength)(50)],
  zip: [_validation.required, _validation.zip],
  ownBike: [],
  email: [_validation.required, _validation.email],
  terms: [_validation.isTrue]
});
exports.default = (0, _lruMemoize2.default)(10)(applicationFormValidation);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ApplicationForm/applicationFormValidation.js
// module id = 1098
// module chunks = 0